import { render, staticRenderFns } from "./PurchaseSuggestion.vue?vue&type=template&id=d41ad6a2&scoped=true&"
import script from "./PurchaseSuggestion.vue?vue&type=script&lang=js&"
export * from "./PurchaseSuggestion.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseSuggestion.vue?vue&type=style&index=0&id=d41ad6a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41ad6a2",
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn,QTable,QSpinner} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn,QTable,QSpinner})
